import createImageIcon from './createImageIcon';
import path from './hour-glass-high.svg';

export default createImageIcon({displayName: 'HourGlassHighIcon', path});



// WEBPACK FOOTER //
// ./src/common/components/icons/HourGlassHighIcon.js